export default function SettingsIcon() {
  return (
        <svg
          aria-hidden="true"
          className="h-4 w-4 shrink-0"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m9.5 3-.5 2a7.5 7.5 0 0 0-2 1.2L5 5.6 2.5 9.9 4 11.3a7.5 7.5 0 0 0 0 2.4l-1.5 1.4L5 19.4l2-.6A7.5 7.5 0 0 0 9 20l.5 2h5l.5-2a7.5 7.5 0 0 0 2-1.2l2 .6 2.5-4.3-1.5-1.4a7.5 7.5 0 0 0 0-2.4l1.5-1.4L19 5.6l-2 .6A7.5 7.5 0 0 0 15 5l-.5-2z" />
          <circle cx="12" cy="12.5" r="3" />
        </svg>
  );
}
